import { useEffect, useState } from 'react';
import './ViesCheck.css';

function authFetch(url, options = {}) {
  const token = localStorage.getItem('ozel_token');
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    credentials: 'include',
  });
}

// Knop onder het btw-veld: controleert het nummer direct bij VIES.
// Bij opslaan van de medewerker wordt de controle nogmaals gedaan en als PDF bewaard.
export default function ViesCheck({ btw, bedrijfsnaam }) {
  const [state, setState] = useState(null); // null | 'busy' | result | { error }
  useEffect(() => { setState(null); }, [btw]);

  const check = async () => {
    setState('busy');
    try {
      const r = await authFetch('/api/registratie/vies-check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ btw, bedrijfsnaam }),
      });
      setState(await r.json());
    } catch {
      setState({ error: 'Controle mislukt. Probeer opnieuw.' });
    }
  };

  let result = null;
  if (state && state !== 'busy') {
    if (state.error) result = <span className="vc-msg warn">{state.error}</span>;
    else if (!state.valid) result = <span className="vc-msg bad">✕ Ongeldig btw-nummer volgens VIES</span>;
    else {
      result = (
        <span className={`vc-msg ${state.nameMatch === false ? 'warn' : 'ok'}`}>
          ✓ Geldig{state.name ? ` · ${state.name}` : ''}
          {state.nameMatch === false && ' · naam wijkt af van bedrijfsnaam'}
        </span>
      );
    }
  }

  return (
    <div className="vc">
      <button type="button" className="vc-btn" onClick={check} disabled={!String(btw || '').trim() || state === 'busy'}>
        {state === 'busy' ? 'Controleren…' : 'VIES-check'}
      </button>
      {result}
    </div>
  );
}
